import { render, staticRenderFns } from "./OsCustomFieldsOverview.vue?vue&type=template&id=ed07fc30&scoped=true"
import script from "./OsCustomFieldsOverview.vue?vue&type=script&lang=ts"
export * from "./OsCustomFieldsOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed07fc30",
  null
  
)

export default component.exports